import { ReactNode } from "react";
import { Link } from "react-router-dom";

export default function LegalLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <main className="min-h-screen bg-[#0d1117]">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-8">
        <header className="mb-6">
          <nav className="text-xs text-slate-500 mb-2">
            <Link to="/" className="hover:underline">Start</Link>
            <span className="mx-1">/</span>
            <span className="text-slate-400">{title}</span>
          </nav>
          <h1 className="text-2xl font-bold text-slate-100">{title}</h1>
          {subtitle && <p className="text-slate-400 mt-1">{subtitle}</p>}
        </header>

        <section className="prose prose-invert max-w-none text-sm">
          {children}
        </section>
      </div>
    </main>
  );
}
